import { Component, DestroyRef, effect, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ActiveTelehealthCallService } from '@services';
import { initFlowbite } from 'flowbite';
import { filter, startWith } from 'rxjs';

const MEETING_URL = 'online-meeting';
const MEETING_URL_PATTERN = /(^|\/)online-meeting(\/|$)/;

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  title = 'patient-portal';

  private readonly router = inject(Router);
  private readonly call = inject(ActiveTelehealthCallService);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.call.setSideAllowed(false);

    effect(() => {
      const open = this.call.isOpen();
      const onMeeting = this.isOnMeeting();
      if (open && !onMeeting) {
        void this.router.navigateByUrl(MEETING_URL);
      } else if (!open && onMeeting) {
        void this.router.navigateByUrl('dashboard');
      }
    });

    effect(() => {
      if (
        this.call.isOpen() &&
        this.call.displayMode() === 'mini' &&
        this.isOnMeeting()
      ) {
        void this.router.navigateByUrl('dashboard');
      }
    });
  }

  ngOnInit(): void {
    initFlowbite();

    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        ),
        startWith(null),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        if (!this.call.isOpen()) {
          return;
        }
        this.call.setDisplayMode(this.isOnMeeting() ? 'full' : 'mini');
      });
  }

  private isOnMeeting(): boolean {
    return MEETING_URL_PATTERN.test(this.router.url.split(/[?#]/)[0]);
  }
}
